import {redirectOrSendEventIfRequired} from './authentication/redirect';
import {determineSigninUrl, determineSignupUrl} from './authentication/signin-signup-full-page';
import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';

if (!window.HopConnectSettings) {
    window.HopConnectSettings = {
        tolerateUserApiUnavailability: false,
    };
}

Hop.connect = {};

Hop.defineModule('signin-mandatory', (root) => {
    function addListener() {
        root.addEventListener('click', showSigninModal);
    }

    function showSigninModal(e) {
        const actuatedElement = e.currentTarget;

        const isConnected = actuatedElement.getAttribute('data-is-connected');
        if (isConnected === 'true') {
            return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        Hop.connect.control.redirectToSigninIfNotConnected(actuatedElement);
    }

    addListener();

    return function destroy() {
        root.removeEventListener('click', showSigninModal);
    };
});

$(document).ready(() => {
    $(document).on('submit', 'form.signin-mandatory', function (e) {
        // eslint-disable-next-line no-invalid-this
        const el = this;
        const $el = $(el);

        $el.data('hop-can-submit', true);

        if ($el.data('hop-connected') === true) {
            // allow default action
            return;
        }

        e.preventDefault();
        if (Hop.hasFormValidation()) {
            if (el.checkValidity()) {
                Hop.connect.control.redirectToSigninIfNotConnected($el);
            }
        } else {
            Hop.connect.control.redirectToSigninIfNotConnected($el);
        }
    });
});

(function ($, win, doc, Hop) {
    const Control = function () {
        this._init();
    };
    Control.prototype = {
        _init: function () {
            this.id = 'connectControl';
        },

        testConnected: function () {
            const dfd = jQuery.Deferred();
            $.ajax({
                url: '/api/user/connected',
                type: 'GET',
                cache: false,
            })
                .done((connected) => {
                    dfd.resolve(connected);
                })
                .fail((jqXHR, textStatus) => {
                    pushNotification(`${Hop.message('connect.popup.signup.error')}: ${textStatus} - ${jqXHR.responseText}`, {
                        level: 'error',
                    });
                });
            return dfd.promise();
        },

        _connectionHandler: function (tag) {
            if (tag.attr('data-callback')) {
                eval(tag.attr('data-callback'));
            } else {
                redirectOrSendEventIfRequired(tag);
            }
        },

        redirectToSigninIfNotConnected: function (tag) {
            return this._redirectUserIfNotConnected(tag, 'SIGNIN');
        },

        redirectToSignupIfNotConnected: function (tag) {
            return this._redirectUserIfNotConnected(tag, 'SIGNUP');
        },

        _redirectUserIfNotConnected: function (tag, pageWhereToRedirect) {
            if (!(tag instanceof jQuery)) {
                tag = $(tag);
            }

            const domTag = tag instanceof jQuery ? tag[0] : tag;

            if (tag.data('is-connected')) {
                this._connectionHandler(tag);
                return;
            }

            const self = this;
            $.ajax({
                url: '/api/user/connected',
                type: 'GET',
                cache: false,
            })
                .done((isConnected) => {
                    if (isConnected) {
                        self._connectionHandler(tag);
                    } else {
                        if (pageWhereToRedirect === 'SIGNUP' || tag.attr('data-show-signup-first')) {
                            window.location.assign(determineSignupUrl(domTag));
                        } else {
                            window.location.assign(determineSigninUrl(domTag));
                        }
                    }
                })
                .fail((jqXHR, textStatus) => {
                    if (window.HopConnectSettings.tolerateUserApiUnavailability) {
                        console.error(
                            'Tolerating User API unavailability and pretending use is indeed connected.\n' +
                                `Following error is ignored: ${textStatus}: ${jqXHR.responseText}`,
                        );
                        self._connectionHandler(tag);
                    } else {
                        pushNotification(`${Hop.message('connect.popup.signup.error')}: ${textStatus} - ${jqXHR.responseText}`, {
                            level: 'error',
                        });
                    }
                });
        },
    };

    Hop.connect.control = Hop.storeObj(new Control());
})(jQuery, window, document, (window.Hop = window.Hop || {}));
